import React from 'react';

import { Container } from './styles';

export const NotFound: React.FC = () => {
  return <Container>Not found</Container>;
};
